<template>
  <global-dialog-card
    v-model="model"
    :title="$t('lokacija')"
    :subtitle="restaurant.name"
    hide-actions
  >
    <p class="mt-2">
      {{ $t("lokacija") }}:
      <span class="font-weight-bold">
        {{
          [toLatin(restaurant.address), toLatin(restaurant.city?.name)]
            .filter(Boolean)
            .join(", ")
        }}
      </span>
    </p>
    <p>
      {{ $t("lati") }}:
      <span class="font-weight-bold">{{ translate(restaurant.latitude) }}</span>
    </p>
    <p>
      {{ $t("long") }}:
      <span class="font-weight-bold">{{ translate(restaurant.longitude) }}</span>
    </p>
    <p>
      <v-icon class="mr-2">mdi mdi-phone</v-icon>
      {{ $t("phone") }}:
      <span class="font-weight-bold"> {{ translate(restaurant.phone) }}</span>
    </p>
    <p>
      <v-icon class="mr-2">mdi mdi-map-marker</v-icon>
      <a target="_blank" :href="googleMapsUrl"> Google maps </a>
      <span style="display: block">
        {{ coordinatesText }}
      </span>
    </p>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  name: "RestaurantLocationDialog",
  mixins: [hasModel],
  props: {
    restaurant: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    googleMapsUrl() {
      if (!this.restaurant.latitude || !this.restaurant.longitude) {
        return "#";
      }
      return `https://www.google.com/maps/search/?api=1&query=${this.restaurant.latitude},${this.restaurant.longitude}`;
    },
    coordinatesText() {
      if (!this.restaurant.latitude || !this.restaurant.longitude) {
        return "";
      }
      return `${this.restaurant.latitude}, ${this.restaurant.longitude}`;
    },
  },
};
</script>
